// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2ZYwt","selects":"Documents_selects__-4MGR"};